import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-full-width-img',
  templateUrl: './full-width-img.component.html',
  styleUrls: ['./full-width-img.component.scss']
})
export class FullWidthImgComponent {
  @Input() imageSrc = '';
  @Input() imageSrcDesktop = '';
  @Input() imageSrcMobile = '';
  @Input() imageAlt = '';

  get desktopSrc(): string {
    return this.imageSrcDesktop || this.imageSrc;
  }

  get mobileSrc(): string {
    return this.imageSrcMobile || this.desktopSrc;
  }
}
